import {type} from './utils'
export default function setDefaultInterceptors(axiosInstance) {
  axiosInstance.interceptors.request.use(config => {
    // 支持vue-resource的before
    if (typeof config.before === 'function') {
      config.before(config)
    }
    return config
  })

  axiosInstance.interceptors.response.use(response => {
    // 兼容vue-resource response相关的属性
    response.json = function() {
      return response.data
    }
    Object.defineProperty(response, 'body', {
      get() {
        return this.data
      },
      set(val) {
        this.data = val
      },
      enumerable: true
    })
    // 防止业务不判断直接取值
    response.headers || (response.headers = {})
    response.headers.get = function(key) {
      return response.headers[key]
    }
    return response
  })
}
